import { useState, useContext, useEffect } from "react";
import './../../index.css'
import systemContext from "../../_context/systemContext";
import { Spinner, Form, Button, Card, Row, Col, Alert, ListGroup, Badge } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { vscService } from "../../_services/vscService";
import { FaSave, FaTimes, FaExclamationTriangle, FaEye, FaCheck, FaTrash, FaCalendarTimes } from "react-icons/fa";
import Swal from 'sweetalert2';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

// Importar DataTable
import DataTable from 'react-data-table-component';

const Configuracion = () => {    
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();    
    const [loading, setLoading] = useState(false);
    const [loadingPorcentajes, setLoadingPorcentajes] = useState(false);
    const [loadingConfiguraciones, setLoadingConfiguraciones] = useState(false);
    const [sociedades, setSociedades] = useState([]);
    const [segmentos, setSegmentos] = useState([]);
    const [motivos, setMotivos] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [porcentajes, setPorcentajes] = useState([]);
    const [porcentajeFiltrado, setPorcentajeFiltrado] = useState(null);
    const [errorPorcentajes, setErrorPorcentajes] = useState('');
    const [busquedaCliente, setBusquedaCliente] = useState('');
    const [clientesEncontrados, setClientesEncontrados] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [buscandoCliente, setBuscandoCliente] = useState(false);
    const [errorCliente, setErrorCliente] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [configuraciones, setConfiguraciones] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const filteredItems = configuraciones.filter(item => {
        const searchText = filterText.toLowerCase();
        const estadoTexto = item.activo ? 'activa' : 'inactiva';        
        return (
            item.cveCompania.toLowerCase().includes(searchText) ||
            item.tipoVenta.toLowerCase().includes(searchText) ||
            item.configurarPor.toLowerCase().includes(searchText) ||
            (item.idCliente && item.idCliente.toLowerCase().includes(searchText)) ||
            (item.idSegmento && item.idSegmento.toLowerCase().includes(searchText)) ||
            (item.idCadena && item.idCadena.toLowerCase().includes(searchText)) ||
            item.usuarioAlta.toLowerCase().includes(searchText) ||
            estadoTexto.includes(searchText)
        );
    });
    // Componente del buscador
    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar en configuraciones..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {configuraciones.length} registros
                {filterText && (
                    <button 
                        className="nova-clear-search"
                        onClick={() => {
                            setFilterText('');
                            setResetPaginationToggle(!resetPaginationToggle);
                        }}
                    >
                        Limpiar
                    </button>
                )}
            </div>
        </div>
    );
    
    const [formData, setFormData] = useState({
        sociedad: '',
        tipoVenta: 'fisico',
        idPorcentaje: '',
        configurarPor: '',
        idSegmento: '',
        idCadena: '',
        idMotivo: '',
        idCliente: '',
        vigenciaFechaInicio: '',
        vigenciaFechaFin: ''
    });
    const [errors, setErrors] = useState({});
    const [selectedSegmentos, setSelectedSegmentos] = useState([]);
    const [selectedCadenas, setSelectedCadenas] = useState([]);
    const [selectedMotivos, setSelectedMotivos] = useState([]);

    // Opciones fijas para combos
    const opcionesConfiguracion = [
        { valor: 'cadena', descripcion: 'Cadena' },
        { valor: 'segmento', descripcion: 'Segmento' },
        { valor: 'cliente', descripcion: 'Cliente' }
    ];

    const opcionesTipoVenta = [
        { valor: 'fisico', descripcion: 'Cambio Físico' },
        { valor: 'sin_cargo', descripcion: 'Venta Sin Cargo' }
    ];

    // Configuración de columnas para DataTable
    const columnasDataTable = [
        {
            name: 'Sociedad',
            selector: row => row.sociedad,
            sortable: true,
            width: '200px'
        },
        {
            name: 'Tipo Venta',
            selector: row => row.tipoVenta,
            sortable: true,
            width: '120px'
        },
        {
            name: 'Config. Por',
            selector: row => row.configurarPor,
            sortable: true,
            cell: row => (
                <Badge bg={getBadgeConfigurarPor(row.configurarPor)}>
                    {row.configurarPor}
                </Badge>
            ),
            width: '100px'
        },
        {
            name: 'Valor',
            selector: row => row.configurarPor,
            cell: row => (
                <span className="small">
                    {row.configurarPor === 'cliente' 
                        ? `${row.idCliente}`
                        : row.configurarPor === 'segmento'
                        ? `${row.idSegmento?.split(',').length || 0} segmentos`
                        : `${row.idCadena?.split(',').length || 0} cadenas`
                    }
                </span>
            ),
            width: '100px'
        },
        {
            name: 'Porcentaje',
            selector: row => row.idPorcentaje,
            sortable: true,
            cell: row => (
                <strong className="text-primary">
                    {(row.idPorcentaje * 100).toFixed(2)}%
                </strong>
            ),
            width: '100px',
            center: true
        },
        {
            name: 'Vigencia',
            selector: row => row.vigenciaFechaInicio,
            sortable: true,
            cell: row => (
                <div className="small">
                    <div>Inicio: {formatFecha(row.vigenciaFechaInicio)}</div>
                    <div>Fin: {formatFecha(row.vigenciaFechaFin)}</div>
                </div>
            ),
            width: '150px'
        },
        {
            name: 'Estado',
            selector: row => row.activo,
            sortable: true,
            cell: row => (
                <Badge bg={row.activo ? 'success' : 'danger'}>
                    {row.activo ? 'Activa' : 'Inactiva'}
                </Badge>
            ),
            width: '100px',
            center: true
        },
        {
            name: 'Usuario Alta',
            selector: row => row.usuarioAlta,
            sortable: true,
            cell: row => (
                <div className="small">
                    <div>{row.usuarioAlta}</div>
                    <small className="text-muted">{formatFecha(row.fechaAlta)}</small>
                </div>
            ),
            width: '150px'
        },
       {
            name: 'Acciones',
            cell: row => {
                // Función para verificar si venció
                const esConfiguracionVencida = (fechaFin) => {
                    const hoy = new Date();
                    hoy.setHours(0, 0, 0, 0);
                    const fin = new Date(fechaFin);
                    fin.setHours(0, 0, 0, 0);
                    return fin < hoy;
                };
                
                const vencida = esConfiguracionVencida(row.vigenciaFechaFin);
                const formatearFecha = (fecha) => new Date(fecha).toLocaleDateString('es-MX');
                
                // Tooltips individuales para cada elemento
                const tooltipVer = vencida 
                    ? `Ver configuración (VENCIDA)\nFinalizó: ${formatearFecha(row.vigenciaFechaFin)}`
                    : `Ver detalles de la configuración`;
                
                const tooltipEstado = vencida
                    ? `CONFIGURACIÓN VENCIDA\nFinalizó: ${formatearFecha(row.vigenciaFechaFin)}\nYa no está disponible para uso`
                    : row.activo
                    ? `Desactivar configuración\nVálida hasta: ${formatearFecha(row.vigenciaFechaFin)}`
                    : `Activar configuración\nVálida hasta: ${formatearFecha(row.vigenciaFechaFin)}`;
                
                return (
                    <div className="nova-grid-actions">
                        {/* Botón VER */}
                        <button 
                            className={`nova-btn-action ${vencida ? 'nova-btn-view-vencida' : 'nova-btn-view'}`}
                            onClick={() => handleVerConfiguracion(row)}
                            title={tooltipVer}
                        >
                            <FaEye className="nova-action-icon" />
                        </button>
                        
                        {/* Indicador/Botón secundario */}
                        {vencida ? (
                            <div 
                                className="nova-status-indicator"
                                title={tooltipEstado}
                            >
                                <FaCalendarTimes className="nova-status-icon" />
                            </div>
                        ) : row.activo ? (
                            <button 
                                className="nova-btn-action nova-btn-delete"
                                onClick={() => handleEliminarConfiguracion(row)}
                                title={tooltipEstado}
                            >
                                <FaTrash className="nova-action-icon" />
                            </button>
                        ) : (
                            <button 
                                className="nova-btn-action nova-btn-activate"
                                onClick={() => handleEliminarConfiguracion(row)}
                                title={tooltipEstado}
                            >
                                <FaCheck className="nova-action-icon" />
                            </button>
                        )}
                    </div>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '100px',
        },
    ];

    // Estilos personalizados para DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #dee2e6',
                fontSize: '0.875rem',
                fontWeight: 'bold'
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '0.75rem',
                fontWeight: 'bold'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '0.75rem',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '48px',
            },
        },
        pagination: {
            style: {
                fontSize: '0.75rem',
            },
        },
    };

    // Cargar combos y configuraciones al iniciar
    useEffect(() => {
        cargarCombos();
        cargarConfiguraciones();
    }, []);

    // Cargar porcentajes cuando cambie la sociedad
    useEffect(() => {
        if (formData.sociedad) {
            cargarPorcentajes(formData.sociedad);
        } else {
            setPorcentajes([]);
            setPorcentajeFiltrado(null);
            setErrorPorcentajes('');
        }
    }, [formData.sociedad]);

    // Filtrar porcentaje cuando cambie el tipo de venta o se carguen los porcentajes
    useEffect(() => {
        if(formData.sociedad && porcentajes.length > 0){
            filtrarPorcentaje();
        }
    }, [formData.tipoVenta, porcentajes, formData.sociedad]);

    // Búsqueda de cliente con debounce
    useEffect(() => {
        if (formData.configurarPor === 'cliente' && busquedaCliente.trim().length >= 5) {
            const delayDebounceFn = setTimeout(() => {
                buscarCliente(busquedaCliente.trim());
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        } else if (formData.configurarPor === 'cliente' && busquedaCliente.trim().length === 0) {
            setClientesEncontrados([]);
            setErrorCliente('');
        }
    }, [busquedaCliente, formData.configurarPor]);

    // Actualizar formData cuando cambien las selecciones múltiples
    useEffect(() => {
        // Concatenar segmentos seleccionados
        if (selectedSegmentos.length > 0) {
            const segmentosIds = selectedSegmentos.map(seg => seg.clave).join(',');
            setFormData(prev => ({ ...prev, idSegmento: segmentosIds }));
        } else {
            setFormData(prev => ({ ...prev, idSegmento: '' }));
        }
        // Concatenar cadenas seleccionadas
        if (selectedCadenas.length > 0) {
            const cadenasIds = selectedCadenas.map(cad => cad.clave).join(',');
            setFormData(prev => ({ ...prev, idCadena: cadenasIds }));
        } else {
            setFormData(prev => ({ ...prev, idCadena: '' }));
        }
        // Concatenar motivos seleccionados
        if (selectedMotivos.length > 0) {
            const motivosIds = selectedMotivos.map(mot => mot.id).join(',');
            setFormData(prev => ({ ...prev, idMotivo: motivosIds }));
        } else {
            setFormData(prev => ({ ...prev, idMotivo: '' }));
        }
        // Para cliente
        if (formData.configurarPor === 'cliente' && clienteSeleccionado) {
            setFormData(prev => ({ ...prev, idCliente: clienteSeleccionado.clienteId }));
        } else if (formData.configurarPor === 'cliente' && !clienteSeleccionado) {
            setFormData(prev => ({ ...prev, idCliente: '' }));
        }
        // Para vigencias
        setFormData(prev => ({ 
            ...prev, 
            vigenciaFechaInicio: fechaInicio,
            vigenciaFechaFin: fechaFin
        }));
    }, [selectedSegmentos, selectedCadenas, selectedMotivos, clienteSeleccionado, formData.configurarPor, fechaInicio, fechaFin]);

    // FUNCIONES PRINCIPALES (se mantienen igual)
    const cargarCombos = async () => {
        try {
            const respuestaSociedades = await vscService.getSociedades();
            if (respuestaSociedades.status === "OK") {
                const sociedadesData = respuestaSociedades.content.sociedades || respuestaSociedades.content.data || respuestaSociedades.data || [];
                setSociedades(sociedadesData);
            }
            const respuestaCadenas = await vscService.getCadenas();
            if (respuestaCadenas.status === "OK") {
                const cadenasData = respuestaCadenas.content.cadenas || [];
                setCadenas(cadenasData);
            }
            const respuestaSegmentos = await vscService.getSegmentos();
            if (respuestaSegmentos.status === "OK") {
                const segmentosData = respuestaSegmentos.content.segmentos || respuestaSegmentos.content.data || respuestaSegmentos.data || [];
                setSegmentos(segmentosData);
            }
            const respuestaMotivos = await vscService.getMotivosVSC();
            if (respuestaMotivos.status === "OK") {
                const motivosData = respuestaMotivos.content.motivos || respuestaMotivos.content.data || respuestaMotivos.data || [];
                setMotivos(motivosData);
            }
        } catch (error) {
            console.error('Error al cargar combos:', error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar datos",
                text: "No se pudieron cargar algunos datos necesarios.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        }
    };

    const cargarPorcentajes = async (sociedad) => {
        setLoadingPorcentajes(true);
        setErrorPorcentajes('');
        setPorcentajeFiltrado(null);        
        try {
            const respuestaPorcentajes = await vscService.getPorcentajeBySociedad(sociedad);
            if (respuestaPorcentajes.status === "OK") {
                const porcentajesData = respuestaPorcentajes.content.porcentajes || [];
                setPorcentajes(porcentajesData);                
                if (porcentajesData.length === 0) {
                    setErrorPorcentajes(`No hay porcentajes registrados para la sociedad ${sociedad}`);
                }
            } else {
                setErrorPorcentajes('Error al cargar los porcentajes');
            }
        } catch (error) {
            console.error('Error al cargar porcentajes:', error);
            setErrorPorcentajes('Error al cargar los porcentajes');
            setPorcentajes([]);
        } finally {
            setLoadingPorcentajes(false);
        }
    };

    const filtrarPorcentaje = () => {
    if(!formData.sociedad || porcentajes.length === 0){
        setPorcentajeFiltrado(null);
        setFormData(prev => ({ ...prev, idPorcentaje: "" }));
        return;
    }

    const porcentajeEncontrado = porcentajes.find(p => {
        const tipo = (p.tipoVenta || "").toLowerCase();

        if(formData.tipoVenta === "fisico"){
        return tipo.includes("cambio físico") ||
                tipo.includes("cambio fisico") ||
                tipo.includes("fisico");
        }

        if(formData.tipoVenta === "sin_cargo"){
        return tipo.includes("sin cargo") ||
                tipo.includes("venta sin cargo");
        }

        return false;
    });

    if(porcentajeEncontrado){
        setPorcentajeFiltrado(porcentajeEncontrado);
        setErrorPorcentajes("");

        setFormData(prev => ({
        ...prev,
        idPorcentaje: porcentajeEncontrado.id.toString()
        }));
    }else{
        setPorcentajeFiltrado(null);

        setFormData(prev => ({
        ...prev,
        idPorcentaje: ""
        }));

        setErrorPorcentajes(
        `No se encontró porcentaje para ${
            formData.tipoVenta === "fisico"
            ? "Cambio Físico"
            : "Venta Sin Cargo"
        }`
        );
    }
    };

    const buscarCliente = async (texto) => {
        setBuscandoCliente(true);
        setErrorCliente('');
        try {
            const respuesta = await vscService.getClientes(texto);
            if (respuesta.status === "OK") {
                const clientesData = respuesta.content.clientes || [];
                setClientesEncontrados(clientesData);
                if (clientesData.length === 0) {
                    setErrorCliente('No se encontraron clientes con ese criterio');
                }
            } else {
                setErrorCliente('Error en la búsqueda de clientes');
            }
        } catch (error) {
            console.error('Error al buscar cliente:', error);
            setErrorCliente('Error al buscar cliente');
            setClientesEncontrados([]);
        } finally {
            setBuscandoCliente(false);
        }
    };

    // MANEJADORES DE EVENTOS (se mantienen igual)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));        
        // Limpiar error del campo cuando el usuario empiece a escribir
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
        // Si cambia "configurarPor", limpiar las selecciones correspondientes
        if (name === 'configurarPor') {
            if (value === 'segmento') {
                setSelectedCadenas([]);
                setClienteSeleccionado(null);
                setBusquedaCliente('');
            } else if (value === 'cadena') {
                setSelectedSegmentos([]);
                setClienteSeleccionado(null);
                setBusquedaCliente('');
            } else if (value === 'cliente') {
                setSelectedSegmentos([]);
                setSelectedCadenas([]);
            }
        }
        // Si cambia la sociedad, limpiar porcentaje y errores
        if (name === 'sociedad') {
            setFormData(prev => ({
                ...prev,
                idPorcentaje: ''
            }));
            setErrorPorcentajes('');
            setPorcentajeFiltrado(null);
        }
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCadenaSelection = (selected) => {
        setSelectedCadenas(selected);
    };

    const handleSegmentoSelection = (selected) => {
        setSelectedSegmentos(selected);
    };

    const handleMotivoSelection = (selected) => {
        setSelectedMotivos(selected);
    };

    const handleClienteSelection = (cliente) => {
        setClienteSeleccionado(cliente);
        setFormData(prev => ({ 
            ...prev, 
            idCliente: cliente.clienteId 
        }));
        // Limpiar búsqueda y mostrar solo en el Alert
        setBusquedaCliente('');
        setErrorCliente('');
        setClientesEncontrados([]);
    };

    const handleBusquedaClienteChange = (e) => {
        const valor = e.target.value;
        setBusquedaCliente(valor);
        
        // Si se borra el texto, limpiar selección
        if (valor === '') {
            setClienteSeleccionado(null);
            setFormData(prev => ({ ...prev, idCliente: '' }));
            setErrorCliente('');
            setClientesEncontrados([]);
        }
    };

    const handleFechaInicioChange = (e) => {
        const valor = e.target.value;
        setFechaInicio(valor);
        
        const fechaInicioDate = new Date(valor);
        const fechaFinDate = new Date(fechaFin);
        
        // Validar que fecha fin no sea menor que fecha inicio
        if (fechaFin && fechaFinDate < fechaInicioDate) {
            setErrors(prev => ({
                ...prev,
                vigenciaFechaFin: 'La fecha fin no puede ser menor que la fecha inicio'
            }));
        } 
        else {
            // Limpiar errores si todo está bien
            setErrors(prev => ({
                ...prev,
                vigenciaFechaInicio: '',
                vigenciaFechaFin: ''
            }));
        }
    };

    const handleFechaFinChange = (e) => {
        const valor = e.target.value;
        setFechaFin(valor);
        
        const fechaFinDate = new Date(valor);
        const fechaInicioDate = new Date(fechaInicio);
        const fechaActual = new Date();
        fechaActual.setHours(0, 0, 0, 0); // Normalizar a inicio del día
        
        // Validar que fecha fin no sea menor que fecha inicio
        if (fechaInicio && fechaFinDate < fechaInicioDate) {
            setErrors(prev => ({
                ...prev,
                vigenciaFechaFin: 'La fecha fin no puede ser menor que la fecha inicio'
            }));
        } 
        // Validar que fecha fin no sea menor que fecha actual
        else if (fechaFinDate < fechaActual) {
            setErrors(prev => ({
                ...prev,
                vigenciaFechaFin: 'La fecha fin no puede ser menor a la fecha actual'
            }));
        }
        else {
            // Limpiar errores si todo está bien
            setErrors(prev => ({
                ...prev,
                vigenciaFechaFin: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            await guardarConfiguracion();
        }
    };

    const handleReset = () => {
        setFormData({
            sociedad: '',
            tipoVenta: 'fisico',
            idPorcentaje: '',
            configurarPor: '',
            idSegmento: '',
            idCadena: '',
            idMotivo: '',
            idCliente: '',
            vigenciaFechaInicio: '',
            vigenciaFechaFin: ''
        });
        setSelectedSegmentos([]);
        setSelectedCadenas([]);
        setSelectedMotivos([]);
        setErrors({});
        setPorcentajeFiltrado(null);
        setErrorPorcentajes('');
        // Limpiar estados de cliente
        setBusquedaCliente('');
        setClienteSeleccionado(null);
        setClientesEncontrados([]);
        setErrorCliente('');
        // Limpiar fechas
        setFechaInicio('');
        setFechaFin('');
    };

    // VALIDACIONES (se mantienen igual)
    const validateForm = () => {
        const newErrors = {};        
        if (!formData.sociedad) {
            newErrors.sociedad = 'La sociedad es requerida';
        }        
        if (!formData.tipoVenta) {
            newErrors.tipoVenta = 'El tipo de venta es requerido';
        }        
        if (!formData.idPorcentaje) {
            newErrors.idPorcentaje = 'El porcentaje es requerido';
        }        
        if (!formData.configurarPor) {
            newErrors.configurarPor = 'La configuración por es requerida';
        }        
        if (formData.configurarPor === 'segmento' && !formData.idSegmento) {
            newErrors.idSegmento = 'Al menos un segmento es requerido';
        }        
        if (formData.configurarPor === 'cadena' && !formData.idCadena) {
            newErrors.idCadena = 'Al menos una cadena es requerida';
        }
        if (formData.configurarPor === 'cliente' && !formData.idCliente) {
            newErrors.idCliente = 'Debe seleccionar un cliente válido';
        }        
        if (!formData.idMotivo) {
            newErrors.idMotivo = 'Al menos un motivo es requerido';
        }
        // Validaciones para vigencias
        if (!formData.vigenciaFechaInicio) {
            newErrors.vigenciaFechaInicio = 'La fecha de inicio es requerida';
        }
        if (!formData.vigenciaFechaFin) {
            newErrors.vigenciaFechaFin = 'La fecha de fin es requerida';
        }
        
        if (formData.vigenciaFechaInicio && formData.vigenciaFechaFin) {
            const inicio = new Date(formData.vigenciaFechaInicio);
            const fin = new Date(formData.vigenciaFechaFin);
            const hoy = new Date();
            hoy.setHours(0, 0, 0, 0); // Normalizar a inicio del día
            
            if (fin < inicio) {
                newErrors.vigenciaFechaFin = 'La fecha fin no puede ser menor que la fecha inicio';
            }
            
            // Fecha fin no puede ser menor a hoy
            if (fin < hoy) {
                newErrors.vigenciaFechaFin = 'La fecha fin no puede ser menor a la fecha actual';
            }
        }        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // GUARDAR CONFIGURACIÓN (se mantiene igual)
    const guardarConfiguracion = async () => {
        setLoading(true);
        try {
            // Obtener el texto descriptivo del tipo de venta
            const tipoVentaDescripcion = opcionesTipoVenta.find(
                tipo => tipo.valor === formData.tipoVenta
            )?.descripcion || formData.tipoVenta;

            // Obtener el valor del porcentaje
            const valorPorcentaje = porcentajeFiltrado?.porcentaje || 0;

            // Preparar datos para enviar
            const configData = {
                ConfigurarPor: formData.configurarPor,
                CveCompania: formData.sociedad,
                TipoVenta: tipoVentaDescripcion,
                IdMotivo: formData.idMotivo,
                IdPorcentaje: valorPorcentaje,
                IdSegmento: formData.configurarPor === 'segmento' ? formData.idSegmento : null,
                IdCadena: formData.configurarPor === 'cadena' ? formData.idCadena : null,
                IdCliente: formData.configurarPor === 'cliente' ? formData.idCliente : null,
                VigenciaFechaInicio: formData.vigenciaFechaInicio,
                VigenciaFechaFin: formData.vigenciaFechaFin,
                UsuarioAlta: user.nombre,
                MailUsuarioAlta: user.email
            };

            const resultado = await vscService.postInsertaConfiguracion(configData);

            if (resultado.status === "OK") {
                // Limpiar formulario después de guardar
                setFormData({
                    sociedad: '',
                    tipoVenta: 'fisico',
                    idPorcentaje: '',
                    configurarPor: '',
                    idSegmento: '',
                    idCadena: '',
                    idMotivo: '',
                    idCliente: '',
                    vigenciaFechaInicio: '',
                    vigenciaFechaFin: ''
                });
                setSelectedSegmentos([]);
                setSelectedCadenas([]);
                setSelectedMotivos([]);
                setPorcentajeFiltrado(null);
                setErrorPorcentajes('');
                // Limpiar estados de cliente
                setBusquedaCliente('');
                setClienteSeleccionado(null);
                setClientesEncontrados([]);
                setErrorCliente('');
                // Limpiar fechas
                setFechaInicio('');
                setFechaFin('');

                // RECARGAR CONFIGURACIONES
                await cargarConfiguraciones();

                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Configuración guardada con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }
        } catch (error) {
            const mensajeError = error || '';
            if (mensajeError.includes("Violation of PRIMARY KEY constraint")) {
            Swal.fire({
                icon: "warning",
                title: "Configuración duplicada",
                text: "Ya existe una configuración con los mismos parámetros. Verifícalos antes de guardar.",
                confirmButtonColor: "#3085d6",
            });
            } else {
            Swal.fire({
                icon: "error",
                title: "Error al insertar configuración",
                text: mensajeError || "Ocurrió un error inesperado.",
                confirmButtonColor: "#d33",
            });
            }
            console.error("Error al insertar configuración:", mensajeError);
        } finally {
            setLoading(false);
        }
    };

    // FUNCIONES PARA EL DATATABLE
    const cargarConfiguraciones = async () => {
        setLoadingConfiguraciones(true);
        try {
            const respuesta = await vscService.getConfiguraciones();
            if (respuesta.status === "OK") {
                const configuracionesData = respuesta.content.configuraciones || [];
                setConfiguraciones(configuracionesData);
            }
        } catch (error) {
            console.error('Error al cargar configuraciones:', error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar configuraciones",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setLoadingConfiguraciones(false);
        }
    };

    // Funciones auxiliares (se mantienen igual)
    const formatFecha = (fecha) => {
        return new Date(fecha).toLocaleDateString('es-MX');
    };

    const getBadgeConfigurarPor = (tipo) => {
        const tipos = {
            'cadena': 'primary',
            'segmento': 'success',
            'cliente': 'warning'
        };
        return tipos[tipo] || 'secondary';
    };

    const isVigenciaActiva = (fechaInicio, fechaFin) => {
        const hoy = new Date();
        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);
        return hoy >= inicio && hoy <= fin;
    };

    // Nuevas funciones para acciones del DataTable
    const handleVerConfiguracion = async (configuracion) => {
        try {
            const resp = await vscService.getConfiguracionPorId(configuracion.id);
            const detalle = resp?.content?.configuracion;
            if (!detalle) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Sin información',
                    text: 'No se encontró el detalle de la configuración.'
                });
                return;
            }
            const porcentaje = detalle.idPorcentaje
                ? `${(detalle.idPorcentaje * 100).toFixed(2)}%`
                : '0.00%';
            Swal.fire({
                title: 'Detalles de Configuración',
                html: `
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;text-align:left;font-size:14px;">
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Clave compañía</strong><br/>
                        ${detalle.cveCompania || '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Tipo de venta</strong><br/>
                        ${detalle.tipoVenta || '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Porcentaje</strong><br/>
                        ${porcentaje}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Usuario Alta</strong><br/>
                        ${detalle.usuarioAlta || '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Fecha Alta</strong><br/>
                        ${detalle.fechaAlta ? formatFecha(detalle.fechaAlta) : '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;">
                        <strong>Segmentos</strong><br/>
                        ${detalle.segmentos || '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;grid-column:1 / span 2;">
                        <strong>Motivos</strong><br/>
                        ${detalle.motivos || '-'}
                    </div>
                    <div style="background:#f4f6f9;border-left:4px solid #6c757d;padding:10px;border-radius:6px;grid-column:1 / span 2;">
                        <strong>Cadenas</strong><br/>
                        ${detalle.cadenas || '-'}
                    </div>
                </div>
                `,
                icon: 'info',
                confirmButtonText: 'Cerrar',
                width: 800
            });
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo obtener el detalle de la configuración.'
            });
        }
    };

    const handleEliminarConfiguracion = (configuracion) => {
        Swal.fire({
            title: configuracion.activo ? 'Desactivar Configuración?' : 'Activar Configuración?',
            text: configuracion.activo 
                ? `¿Estás seguro de desactivar la configuración de ${configuracion.cveCompania}?`
                : `¿Estás seguro de activar la configuración de ${configuracion.cveCompania}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: configuracion.activo ? 'Sí, desactivar' : 'Sí, activar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const jsonData = {
                        idConf: configuracion.id,
                        usuario: user.nombre
                    };
                    
                    const respuesta = await vscService.deleteEliminarConfiguracion(jsonData);
                    
                    if (respuesta.status === "OK") {
                        Swal.fire(
                            'Actualizada',
                            `La configuración ha sido ${configuracion.activo ? 'desactivada' : 'activada'} correctamente.`,
                            'success'
                        );
                        
                        // ***** ESTA ES LA LÍNEA CLAVE *****
                        // Recargar las configuraciones para actualizar la tabla
                        await cargarConfiguraciones();
                        
                    } else {
                        throw new Error(respuesta.message || 'Error en la respuesta del servidor');
                    }
                } catch (error) {
                    console.error("Error al actualizar configuración:", error);
                    Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: 'Error',
                        text: 'No se actualizó la información, favor de intentar de nuevo.',
                        showConfirmButton: false,
                        timer: 2200,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                }
            }
        });
    };

    // RENDER - Manteniendo exactamente la misma estructura
    return (
        <div className="nova-dashboard-balanced">
            {/* Header de la página */}
            <div className="nova-page-header">
                <h3 className="nova-page-title">Configuración</h3>
                <p className="nova-page-subtitle">Captura y consulta de configuraciones</p>
            </div>

            {/* Formulario de captura - COMPACTO (se mantiene igual) */}
            <div className="nova-form-container">
                <Card 
                    className="nova-form-card"
                    style={{ 
                        margin: '0 20px 20px 20px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                    }}
                >
                    <Card.Body style={{ padding: '1.5rem' }}>
                        <Form onSubmit={handleSubmit}>
                            {/* Fila 1: Sociedad y Tipo de Venta - COMPACTA */}
                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Sociedad</Form.Label>
                                        <Form.Select
                                            name="sociedad"
                                            value={formData.sociedad}
                                            onChange={handleChange}
                                            isInvalid={!!errors.sociedad}
                                            size="sm"
                                        >
                                            <option value="">Seleccione...</option>
                                            {sociedades.map(sociedad => (
                                                <option key={sociedad.sociedad} value={sociedad.sociedad}>
                                                    {sociedad.sociedad} - {sociedad.descripcion}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid" className="small">
                                            {errors.sociedad}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                
                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Tipo de Venta</Form.Label>
                                        <div>
                                            {opcionesTipoVenta.map(tipo => (
                                                <Form.Check
                                                    key={tipo.valor}
                                                    type="radio"
                                                    name="tipoVenta"
                                                    id={`tipoVenta-${tipo.valor}`}
                                                    value={tipo.valor}
                                                    checked={formData.tipoVenta === tipo.valor}
                                                    onChange={handleRadioChange}
                                                    label={tipo.descripcion}
                                                    inline
                                                    className="me-3 small"
                                                />
                                            ))}
                                        </div>
                                        {errors.tipoVenta && (
                                            <div className="text-danger small" style={{ marginTop: '0.25rem' }}>
                                                {errors.tipoVenta}
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Configurar Por</Form.Label>
                                        <Form.Select
                                            name="configurarPor"
                                            value={formData.configurarPor}
                                            onChange={handleChange}
                                            isInvalid={!!errors.configurarPor}
                                            size="sm"
                                        >
                                            <option value="">Seleccione...</option>
                                            {opcionesConfiguracion.map(opcion => (
                                                <option key={opcion.valor} value={opcion.valor}>
                                                    {opcion.descripcion}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid" className="small">
                                            {errors.configurarPor}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Fila 2: Porcentajes y Vigencias - COMPACTA */}
                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Porcentaje autorizado</Form.Label>
                                        {loadingPorcentajes ? (
                                            <div className="d-flex align-items-center small">
                                                <Spinner size="sm" className="me-2" />
                                                <span>Cargando...</span>
                                            </div>
                                        ) : errorPorcentajes ? (
                                            <Alert variant="warning" className="py-1 small">
                                                <FaExclamationTriangle className="me-1" />
                                                {errorPorcentajes}
                                            </Alert>
                                        ) : porcentajeFiltrado ? (
                                            <div>
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    value={`${(porcentajeFiltrado.porcentaje * 100).toFixed(2)}%`}
                                                    disabled
                                                    className="bg-light small"
                                                />
                                            </div>
                                        ) : (
                                            <Form.Text className="text-muted small">
                                                &nbsp; Seleccione sociedad
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Vigencia Inicio</Form.Label>
                                        <Form.Control
                                            type="date"
                                            size="sm"
                                            value={fechaInicio}
                                            onChange={handleFechaInicioChange}
                                            isInvalid={!!errors.vigenciaFechaInicio}
                                        />
                                        <Form.Control.Feedback type="invalid" className="small">
                                            {errors.vigenciaFechaInicio}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>

                                <Col md={4}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Vigencia Fin</Form.Label>
                                        <Form.Control
                                            type="date"
                                            size="sm"
                                            value={fechaFin}
                                            onChange={handleFechaFinChange}
                                            isInvalid={!!errors.vigenciaFechaFin}
                                            min={new Date().toISOString().split('T')[0]}
                                        />
                                        <Form.Control.Feedback type="invalid" className="small">
                                            {errors.vigenciaFechaFin}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Fila 3: Selectores específicos - COMPACTA */}
                            <Row>
                                <Col md={6}>
                                    {formData.configurarPor === 'segmento' && (
                                        <Form.Group className="mb-2">
                                            <Form.Label className="small fw-bold">Segmento</Form.Label>
                                            <Typeahead
                                                id="combo-segmentos"
                                                multiple
                                                options={segmentos}
                                                placeholder="Selecciona segmentos..."
                                                labelKey={(option) => `${option.clave} - ${option.descripcion}`}
                                                onChange={handleSegmentoSelection}
                                                selected={selectedSegmentos}
                                                isInvalid={!!errors.idSegmento}
                                                className={errors.idSegmento ? 'is-invalid' : ''}
                                                size="sm"
                                                clearButton
                                            />
                                            {errors.idSegmento && (
                                                <div className="invalid-feedback d-block small">
                                                    {errors.idSegmento}
                                                </div>
                                            )}
                                        </Form.Group>
                                    )}

                                    {formData.configurarPor === 'cadena' && (
                                        <Form.Group className="mb-2">
                                            <Form.Label className="small fw-bold">Cadena</Form.Label>
                                            <Typeahead
                                                id="combo-cadenas"
                                                multiple
                                                options={cadenas}
                                                placeholder="Selecciona cadenas..."
                                                labelKey={(option) => `${option.clave} - ${option.descripcion}`}
                                                onChange={handleCadenaSelection}
                                                selected={selectedCadenas}
                                                isInvalid={!!errors.idCadena}
                                                className={errors.idCadena ? 'is-invalid' : ''}
                                                size="sm"
                                                clearButton
                                            />
                                            {errors.idCadena && (
                                                <div className="invalid-feedback d-block small">
                                                    {errors.idCadena}
                                                </div>
                                            )}
                                        </Form.Group>
                                    )}

                                    {formData.configurarPor === 'cliente' && (
                                        <Form.Group className="mb-2">
                                            <Form.Label className="small fw-bold">Buscar Cliente</Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    placeholder="ID o nombre (min. 5 caracteres)..."
                                                    value={busquedaCliente}
                                                    onChange={handleBusquedaClienteChange}
                                                    isInvalid={!!errors.idCliente || !!errorCliente}
                                                    disabled={buscandoCliente}
                                                />
                                                {buscandoCliente && (
                                                    <div className="position-absolute top-50 end-0 translate-middle-y me-2">
                                                        <Spinner animation="border" size="sm" />
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {clientesEncontrados.length > 0 && (
                                                <ListGroup className="mt-1" style={{ maxHeight: '120px', overflowY: 'auto' }}>
                                                    {clientesEncontrados.map(cliente => (
                                                        <ListGroup.Item 
                                                            key={cliente.clienteId}
                                                            action
                                                            onClick={() => handleClienteSelection(cliente)}
                                                            className="py-1 small"
                                                        >
                                                            <strong>{cliente.clienteId}</strong> - {cliente.nombreCliente}
                                                        </ListGroup.Item>
                                                    ))}
                                                </ListGroup>
                                            )}
                                            
                                            {clienteSeleccionado && (
                                                <Alert variant="success" className="py-1 mt-1 small">
                                                    <strong>Cliente:</strong> {clienteSeleccionado.clienteId} - {clienteSeleccionado.nombreCliente}
                                                </Alert>
                                            )}
                                        </Form.Group>
                                    )}
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-2">
                                        <Form.Label className="small fw-bold">Motivos VSC</Form.Label>
                                        <Typeahead
                                            id="combo-motivos"
                                            multiple
                                            options={motivos}
                                            placeholder="Selecciona motivos..."
                                            labelKey={(option) => `${option.clave} - ${option.descripcion}`}
                                            onChange={handleMotivoSelection}
                                            selected={selectedMotivos}
                                            isInvalid={!!errors.idMotivo}
                                            className={errors.idMotivo ? 'is-invalid' : ''}
                                            size="sm"
                                            clearButton
                                        />
                                        {errors.idMotivo && (
                                            <div className="invalid-feedback d-block small">
                                                {errors.idMotivo}
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Botones de acción - COMPACTOS */}
                            <div className="nova-form-actions mt-3 pt-3 border-top">
                                <div className="d-flex justify-content-between align-items-center">
                                    <small className="text-muted">
                                        {configuraciones.length} configuraciones guardadas &nbsp;&nbsp;
                                    </small>
                                    <div>
                                        <Button 
                                            variant="outline-secondary" 
                                            onClick={handleReset}
                                            disabled={loading}
                                            size="sm"
                                            className="me-2"
                                        >
                                            <FaTimes className="me-1" />
                                            Limpiar
                                        </Button>
                                        <Button 
                                            variant="primary" 
                                            type="submit"
                                            disabled={loading || !porcentajeFiltrado}
                                            size="sm"
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner size="sm" className="me-1" />
                                                    Guardando...
                                                </>
                                            ) : (
                                                <>
                                                    <FaSave className="me-1" />
                                                    Guardar
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>

            {/* DataTable de Configuraciones Guardadas */}
            <div className="nova-grid-container" style={{ margin: '0 20px' }}>
                <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center py-2">
                        <h6 className="mb-0 fw-bold">Configuraciones Guardadas</h6>
                        <Button 
                            variant="outline-primary" 
                            size="sm"
                            onClick={cargarConfiguraciones}
                            disabled={loadingConfiguraciones}
                        >
                            {loadingConfiguraciones ? <Spinner size="sm" /> : 'Actualizar'}
                        </Button>
                    </Card.Header>
                    <Card.Body className="p-0">
                        {loadingConfiguraciones ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2 text-muted">Cargando configuraciones...</p>
                            </div>
                        ) : configuraciones.length === 0 ? (
                            <div className="text-center py-4">
                                <p className="text-muted">No hay configuraciones guardadas</p>
                            </div>
                        ) : (
                            <DataTable
                                columns={columnasDataTable}
                                data={filteredItems} // Cambiar configuraciones por filteredItems
                                customStyles={customStyles}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                noDataComponent={<div className="text-center py-4">No hay configuraciones guardadas</div>}
                                highlightOnHover
                                striped
                                responsive
                                defaultSortFieldId={1}
                                defaultSortAsc={false}
                                subHeader
                                subHeaderComponent={subHeaderComponent}
                                persistTableHead
                            />
                        )}
                    </Card.Body>
                </Card>
            </div>
            <Tooltip 
                id="actions-tooltip" 
                place="top"
                effect="solid"
                className="nova-tooltip"
                delayShow={300}
            />
        </div>
    );
};

export default Configuracion;